import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Lifebuoy, CheckCircle } from "@phosphor-icons/react";
import { TicketForm } from "./TicketForm";

export function TicketLodged({ reference }) {
  return (
    <div className="flex items-start gap-2.5 rounded-xl border border-[#73bf44]/30 bg-[#73bf44]/[0.06] px-4 py-3" data-testid="ticket-lodged">
      <CheckCircle size={18} weight="fill" className="text-[#73bf44] mt-0.5 shrink-0" />
      <div className="text-sm text-neutral-300 leading-relaxed">
        Ticket <span className="font-mono font-semibold text-white" data-testid="ticket-lodged-ref">{reference}</span> lodged — the OTM tech team will be in touch.
        <span className="block text-xs text-neutral-500 mt-0.5">Track it any time under <Link to="/my-caravan" className="text-[#73bf44] hover:underline">My Caravan → Support</Link>.</span>
      </div>
    </div>
  );
}

// Shown under Nick's reply when he couldn't fully answer (or the customer asked for a ticket).
export function TicketOffer({ msg, isLast, onLodged }) {
  const [mode, setMode] = useState(msg.ticket_form ? "form" : "ask");
  if (msg.ticket_ref) return <div className="mt-2.5"><TicketLodged reference={msg.ticket_ref} /></div>;
  if (!isLast || mode === "dismissed") return null;
  return (
    <motion.div initial={{ opacity: 0, y: 6 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.25, delay: 0.15 }}
      className="mt-2.5 rounded-2xl border border-neutral-800 bg-[#0F0F0F] overflow-hidden" data-testid="ticket-offer">
      <div className="flex items-center gap-3 px-4 py-3 border-b border-neutral-800/70">
        <div className="w-8 h-8 rounded-lg bg-[#73bf44]/10 flex items-center justify-center shrink-0"><Lifebuoy size={17} className="text-[#73bf44]" weight="duotone" /></div>
        <div className="min-w-0 flex-1">
          <div className="text-sm font-semibold text-white">Lodge a technical support ticket?</div>
          <div className="text-xs text-neutral-500">The OTM tech team will review your chat and get back to you.</div>
        </div>
      </div>
      <AnimatePresence mode="wait" initial={false}>
        {mode === "ask" ? (
          <motion.div key="ask" exit={{ opacity: 0 }} className="flex items-center gap-2 px-4 py-3">
            <button onClick={() => setMode("form")} data-testid="ticket-offer-yes" className="bg-[#73bf44] text-[#050505] rounded-full font-semibold px-4 py-2 text-sm hover:bg-[#5fa338] transition-colors">Yes, lodge a ticket</button>
            <button onClick={() => setMode("dismissed")} data-testid="ticket-offer-no" className="text-sm text-neutral-400 hover:text-white px-3 py-2 rounded-full transition-colors">No thanks</button>
          </motion.div>
        ) : (
          <motion.div key="form" initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: "auto" }} className="px-4 py-4">
            <TicketForm messageId={msg.message_id || msg.id} onDone={(t) => onLodged(msg, t.reference)} onCancel={() => setMode("ask")} />
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
}
